import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'timeline-container',
    templateUrl: './timeline.component.html'
})
export class TimelineComponent {}
